import React, { useMemo } from "react";
import { Box, Grid, Typography, TextField, MenuItem } from "@mui/material";

const toNumber = (v, fallback = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

const AccreditationNIRF = ({
  option,
  data = {},                 
  onChange,                
  renderUploadSection,
  readOnly = false,
}) => {
  const years = useMemo(() => {
    const y = new Date().getFullYear();
    return [y, y - 1, y - 2, y - 3, y - 4];
  }, []);

  const handleField = (key) => (e) => {
    const raw = e.target.value;

    if (key === "score") {
      const next = raw === "" ? "" : Math.max(0, toNumber(raw));
      onChange && onChange({ score: next });
      return;
    }

    if (key === "ranking") {
      const next = raw === "" ? "" : Math.max(0, Math.trunc(toNumber(raw)));
      onChange && onChange({ ranking: next });
      return;
    }

    if (key === "year") {
      onChange && onChange({ year: toNumber(raw, years[0]) });
      return;
    }
  };

  const score = data.score ?? 0;
  const ranking = data.ranking ?? 0;
  const year = data.year ?? years[0];

  return (
    <Box display="flex" gap={2}>
      {/* Left: Logo */}
      <Box sx={{ width: 80, pt: 1 }}>
        <img
          src="/assets/images/university-logo/nirf-logo.png"
          alt="NIRF Logo"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </Box>

      {/* Right: Text + Inputs */}
      <Box flex={1}>
        <Typography fontSize={14} fontWeight={600} color="#15243E" mb={2}>
          {option?.label}
        </Typography>

        <Grid container spacing={2}>
          <Grid xs={12} md={2}>
            <Typography fontSize={13} fontWeight={500} mb={0.5}>
              Score
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={score}
              onChange={handleField("score")}
              type="number"
              inputProps={{ step: "0.01", min: 0 }}
              disabled={readOnly}
              sx={{
                "& .MuiInputBase-root": { height: 38 },
                "& .MuiInputBase-input": { fontSize: "13px", padding: "8px 12px" },
              }}
            />
          </Grid>

          <Grid xs={12} md={2}>
            <Typography fontSize={13} fontWeight={500} mb={0.5}>
              Ranking
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={ranking}
              onChange={handleField("ranking")}
              type="number"
              inputProps={{ step: "1", min: 0 }}
              disabled={readOnly}
              sx={{
                "& .MuiInputBase-root": { height: 38 },
                "& .MuiInputBase-input": { fontSize: "13px", padding: "8px 12px" },
              }}
            />
          </Grid>

          <Grid xs={12} md={2}>
            <Typography fontSize={13} fontWeight={500} mb={0.5}>
              Year
            </Typography>
            <TextField
              select
              fullWidth
              size="small"
              value={year}
              onChange={handleField("year")}
              disabled={readOnly}
              sx={{
                "& .MuiInputBase-root": { height: 38 },
                "& .MuiSelect-select": { fontSize: "13px", padding: "6px 12px" },
              }}
            >
              {years.map((y) => (
                <MenuItem key={y} value={y} sx={{ fontSize: "13px" }}>
                  {y}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>

        <Box display="block">{renderUploadSection()}</Box>
      </Box>
    </Box>
  );
};

export default AccreditationNIRF;
